import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { intervalSetAutocomplete, parseGooglePlace } from './utils'
import {TextField, } from "@material-ui/core";

class Autocomplete extends Component {

    constructor(props) {
        super(props);

        this.state = {
            addressQuery: ''
        };
    }

    componentWillUnmount () {
        clearInterval(this.autocompleteInterval)
    }

    render () {
        const { fields, onPlaceChanged, ...rest } = this.props;
        const inputAutoComplete = window.chrome ? 'nope' : 'off';
        return (<TextField type='text' margin="normal" fullWidth required label='Address' value={this.state.addressQuery}
                           onChange={event => {this.setState({addressQuery: event.target.value});}} autoComplete={inputAutoComplete} {...rest} />)
    }

    componentDidMount () {
        const { id, onPlaceChanged, } = this.props;
        const fields = ['address_components', 'formatted_address', 'place_id'];
        const types = ['address'];

        const elem = document.getElementById(id);

        try {
            this.autocomplete = new window['google'].maps.places.Autocomplete(
                elem, {
                    types,
                    componentRestrictions: {
                        country: 'us'
                    }
                }
            );
            this.autocomplete.setFields(fields);

            this.autocomplete.addListener('place_changed', () => {
                const place = this.autocomplete.getPlace();
                this.setState({addressQuery: place.formatted_address});
                onPlaceChanged(parseGooglePlace(place))
            });

            this.autocompleteInterval = intervalSetAutocomplete(elem)
        }
        catch (e) {
            console.error(e)
        }
    }

}

Autocomplete.propTypes = {
    className: PropTypes.string,
    id: PropTypes.string.isRequired,
    onPlaceChanged: PropTypes.func.isRequired,
    style: PropTypes.object,
};

export default Autocomplete
